import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const integrationStatusEnum = z.enum(["pending", "imported", "conflict"]);

const malomoIntegrationStatusSchema = z.object({
  kind: z.string(),
  connectionKind: z.string(),
  status: integrationStatusEnum,
  conflictReason: z.string().optional(),
});

export const getMalomoMigrationStatus = {
  name: "getMalomoMigrationStatus" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    found: z.boolean(),
    shopifyDomain: z.string().optional(),
    merchantName: z.string().optional(),
    hasCarrierMappings: z.boolean(),
    carrierMappingsCount: z.number(),
    carrierMappingsAlreadyImported: z.boolean(),
    hasStalledSettings: z.boolean(),
    stalledSettingsAlreadyImported: z.boolean(),
    integrations: z.array(malomoIntegrationStatusSchema),
    hasAnythingToImport: z.boolean(),
  }),
};
